// src/utils/tracking.js

// --- Code de suivi ---
export const genTrackingCode = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const rand = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `COL-${y}${m}${day}-${rand}`; // ex: COL-20251005-ABCD
};

// --- Table des étapes ---
export const steps = [
  { id: "warehouse", label: "Entrepôt Chine" },
  { id: "container", label: "Mise en conteneur" },
  { id: "lome", label: "Réception à Lomé" },
];

// --- Statut simple basé sur un comptage par étape (compat) ---
// lotsByStep: { warehouse: n, container: n, lome: n }
export const computeStatus = (lotsByStep = {}) => {
  if ((lotsByStep?.lome || 0) > 0) return "recu";
  if ((lotsByStep?.container || 0) > 0) return "en_conteneur";
  if ((lotsByStep?.warehouse || 0) > 0) return "en_entrepot";
  return "en_attente";
};

// --- Aides numériques ---
export const sumBy = (arr = [], key = "qty") =>
  arr.reduce((s, it) => s + Number(it?.[key] || 0), 0);

// --- Couverture (unités) par étape à partir des articles et des lots ---
export const computeCoverage = (articles = [], lots = []) => {
  // total d'unités = somme des qty d'articles
  const totalUnits = sumBy(articles, "qty");

  const wh = sumBy(lots.filter((l) => l.step === "warehouse"), "qty");
  const cont = sumBy(lots.filter((l) => l.step === "container"), "qty");
  const lome = sumBy(lots.filter((l) => l.step === "lome"), "qty");

  const pct = (v) => (totalUnits > 0 ? Math.min(100, Math.round((100 * v) / totalUnits)) : 0);

  return {
    totalUnits,
    warehouse: wh,
    container: cont,
    lome,
    pctWarehouse: pct(wh),
    pctContainer: pct(cont),
    pctLome: pct(lome),
  };
};

// --- Statut paiement ---
export const computePaymentStatus = (estimateXOF = 0, paidXOF = 0) => {
  const est = Number(estimateXOF || 0);
  const paid = Number(paidXOF || 0);
  if (est <= 0 && paid <= 0) return "non_defini"; // pas d’estimation ni de paiement
  if (paid <= 0) return "non_paye";
  if (paid < est) return "partiel";
  return "solde";
};

// --- Statut global dérivé de la couverture (plus strict) ---
export const deriveStatusFromCoverage = (cov) => {
  if (!cov) return "en_attente";
  if (cov.lome >= cov.totalUnits && cov.totalUnits > 0) return "recu";
  if (cov.container >= cov.totalUnits && cov.totalUnits > 0) return "en_conteneur";
  if (cov.warehouse >= cov.totalUnits && cov.totalUnits > 0) return "en_entrepot";
  return "en_attente";
};

// --- Vérifications de cohérence des quantités ---
export const checkCoverageConsistency = (cov) => {
  const issues = [];
  if (!cov) return issues;

  if (cov.container > cov.warehouse)
    issues.push("La quantité en conteneur dépasse la quantité reçue à l'entrepôt.");
  if (cov.lome > cov.container)
    issues.push("La quantité reçue à Lomé dépasse la quantité mise en conteneur.");
  if (cov.warehouse > cov.totalUnits)
    issues.push("La quantité reçue à l'entrepôt dépasse la quantité totale d'articles.");
  if (cov.container > cov.totalUnits)
    issues.push("La quantité en conteneur dépasse la quantité totale d'articles.");
  if (cov.lome > cov.totalUnits)
    issues.push("La quantité reçue à Lomé dépasse la quantité totale d'articles.");

  return issues;
};
